<div id="summary-bar-wrapper">
    <mat-accordion>
        <mat-expansion-panel [expanded]="expandSummaryPanel">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <div class="header-main" *ngIf="application && !isLoading; else headerSkeleton">
                        <div class="header-content">
                            <div class="header-left">
                                <div class="header-left-content">
                                    <div class="header-primary">
                                        <a class="deal-link"
                                            [href]="!isExternalUser(user) ? 'https://crm.zoho.com/crm/org642546092/tab/Potentials/' + (application?.id || '') : null"
                                            [target]="!isExternalUser(user) ? '_blank' : null">
                                            {{ application?.Deal_Name || 'N/A' }}</a>
                                        <span class="amount-info">( {{ displayAmount ? (displayAmount |
                                            currency:'USD':'symbol':'1.2-2') : "N/A" }} )</span>
                                        <span class="loan-type-info" *ngIf="application?.Loan_Type">- {{ application.Loan_Type }}</span>
                                    </div>
                                </div>
                                <div class="header-left-content">
                                    <div class="header-primary">
                                        <span class="next-schedule-call" *ngIf="nextScheduleCall">Next {{nextScheduleCall.purpose}} call:
                                            {{nextScheduleCall.time}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ng-template #headerSkeleton>
                        <div class="header-main">
                            <div class="header-content">
                                <div class="header-left">
                                    <div class="header-primary">
                                        <ngx-skeleton-loader count="1" appearance="line"
                                            [theme]="{ height: '18px', width: '300px', margin: '0' }"></ngx-skeleton-loader>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-card class="summary-content" appearance="outlined">
                <!-- First Row: Stage, Agency, Collector, Creditor, Sales Agent -->
                <div class="row first-row">
                    <!-- Stage Section -->
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="summary-item">
                            <div class="item-label">Stage</div>
                            <div class="item-content">
                                <div *ngIf="application && !isLoading && !isStageUpdating; else stageItemSkeleton"
                                    style="width: 100%; height: 100%;">
                                    <div class="stage-container">
                                        <mat-form-field appearance="outline" class="stage-select">
                                            <mat-select [formControl]="stageFormControl">
                                                <mat-option *ngFor="let option of stageOptions" [value]="option.value">
                                                    {{ option.label }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <div class="stage-buttons">
                                            <!-- Edit button (pen icon) - shown when not in edit mode -->
                                            <button
                                                *ngIf="!isStageEditMode && !isExternalUser(user) && !isStageUpdating"
                                                mat-icon-button class="edit-btn" (click)="enableStageEdit()"
                                                matTooltip="Edit stage">
                                                <mat-icon>edit</mat-icon>
                                            </button>

                                            <!-- Save and Cancel buttons - shown when in edit mode -->
                                            <div *ngIf="isStageEditMode && !isStageUpdating" class="edit-actions">
                                                <button mat-icon-button class="save-btn" (click)="saveStageChange()"
                                                    matTooltip="Save changes">
                                                    <mat-icon>check</mat-icon>
                                                </button>
                                                <button mat-icon-button class="cancel-btn" (click)="cancelStageEdit()"
                                                    matTooltip="Cancel changes">
                                                    <mat-icon>close</mat-icon>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ng-template #stageItemSkeleton>
                                    <ngx-skeleton-loader count="1" appearance="line"
                                        [theme]="{ height: '30px', width: '120px', margin: '0' }"></ngx-skeleton-loader>
                                </ng-template>
                            </div>
                        </div>
                    </div>

                    <!-- Agency Section -->
                    <div class="col-12 col-md-6 col-lg-2">
                        <div class="summary-item">
                            <div class="item-label">Agency</div>
                            <div class="item-content">
                                <div *ngIf="application && !isLoading; else contentItemSkeleton"
                                    style="width: 100%; height: 100%;">
                                    {{ application?.Account_Name?.name || 'N/A' }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Collector Section -->
                    <div class="col-12 col-md-6 col-lg-1">
                        <div class="summary-item">
                            <div class="item-label">Collector</div>
                            <div class="item-content">
                                <div *ngIf="application && !isLoading; else contentItemSkeleton"
                                    style="width: 100%; height: 100%;">
                                    {{ application?.Collector_Formula || 'N/A' }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Creditor Section -->
                    <div class="col-12 col-md-6 col-lg-2">
                        <div class="summary-item">
                            <div class="item-label">Creditor</div>
                            <div class="item-content">
                                <div *ngIf="application && !isLoading; else contentItemSkeleton"
                                    style="width: 100%; height: 100%;">
                                    {{ application?.Creditt || 'N/A' }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Sales Agent Section -->
                    <div class="col-12 col-md-6 col-lg-2">
                        <div class="summary-item">
                            <div class="item-label">Sales Agent</div>
                            <div class="item-content">
                                <div *ngIf="application && !isLoading; else contentItemSkeleton"
                                    style="width: 100%; height: 100%;">
                                    {{ application?.Sales_Agent || 'N/A' }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- AOB Section -->
                    <div class="col-12 col-md-6 col-lg-2">
                        <div class="summary-item">
                            <div class="item-label">AOB file has been created?</div>
                            <div class="item-content">
                                <div *ngIf="application && !isLoading; else contentItemSkeleton"
                                    style="width: 100%; height: 100%;">
                                    {{application?.AOB_file}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Second Row: Tel, DOB, Address -->
                <div class="row second-row">
                    <!-- Phone Section -->
                    <div class="col-12 col-md-6 col-lg-2">
                        <div class="summary-item">
                            <div class="item-label">Tel#</div>
                            <div class="item-content">
                                <div *ngIf="application && !isLoading; else contentItemSkeleton">
                                    {{ formatPhoneNumber(application?.Mobile || application?.Phone) }}
                                    &nbsp;
                                    <mat-icon role="button" class="phone" matTooltip="Call"
                                        (click)="telCall()">phone</mat-icon>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- DOB Section -->
                    <div class="col-12 col-md-6 col-lg-1">
                        <div class="summary-item">
                            <div class="item-label">DOB</div>
                            <div class="item-content">
                                <div *ngIf="application && !isLoading; else contentItemSkeleton"
                                    style="width: 100%; height: 100%;">
                                    {{ application?.Date_of_Birth ? (application.Date_of_Birth | date:'yyyy-MM-dd') :
                                    'N/A' }} ({{ application?.Date_of_Birth ? calculateAge(application.Date_of_Birth) :
                                    'N/A' }})
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Address Section -->
                    <div class="col-12 col-md-12 col-lg-3">
                        <div class="summary-item">
                            <div class="item-label">Address</div>
                            <div class="item-content">
                                <div *ngIf="application && !isLoading; else contentItemSkeleton"
                                    style="width: 100%; height: 100%;">
                                    <ng-container *ngIf="application?.Address1 || application?.City; else noAddress">
                                        {{ (application?.Address1 ? application.Address1 : '') +
                                        (application?.Address_Line_2 ? ', ' + application.Address_Line_2 : '') +
                                        (application?.City ? ', ' + application.City : '') +
                                        (application?.Province1 ? ', ' + application.Province1 : '') +
                                        (application?.Postal_Code ? ', ' + application.Postal_Code : '') }}
                                    </ng-container>
                                    <ng-template #noAddress>N/A</ng-template>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Transunion Status Section -->
                    <div class="col-12 col-md-6 col-lg-2">
                        <div class="summary-item">
                            <div class="item-label">Transunion Status</div>
                            <div class="item-content">
                                <div *ngIf="application && !isLoading; else contentItemSkeleton"
                                    style="width: 100%; height: 100%;">
                                    {{application._isPrimaryConsentPulled? "Successfully": "Not"}} Pulled
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- EC Complete Section -->
                    <div class="col-12 col-md-6 col-lg-2">
                        <div class="summary-item">
                            <div class="item-label">EC Complete</div>
                            <div class="item-content">
                                <div *ngIf="application && !isLoading; else contentItemSkeleton"
                                    style="width: 100%; height: 100%;">
                                    <span class="status-value">
                                        <span>{{ ecCompleteStatus }}</span>
                                        <mat-icon *ngIf="ecCompleteStatus === 'Completed'" class="status-icon status-complete"
                                            matTooltip="Every emergency contact is completed">check_circle</mat-icon>
                                        <mat-icon *ngIf="ecCompleteStatus === 'Incomplete'" class="status-icon status-incomplete"
                                            matTooltip="An emergency contact is not completed">error</mat-icon>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- VOE Status Section -->
                    <div class="col-12 col-md-6 col-lg-2">
                        <div class="summary-item">
                            <div class="item-label">VOE Status</div>
                            <div class="item-content">
                                <div *ngIf="application && !isLoading; else contentItemSkeleton"
                                    style="width: 100%; height: 100%;">
                                    <span class="status-value">
                                        <span>{{ voeStatus || 'N/A' }}</span>
                                        <mat-icon *ngIf="voeStatus === 'Completed'" class="status-icon status-complete"
                                            matTooltip="The VOE is completed">check_circle</mat-icon>
                                        <mat-icon *ngIf="voeStatus === 'Incomplete'" class="status-icon status-incomplete"
                                            matTooltip="The VOE is pending or was attempted">error</mat-icon>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </mat-card>

            <!-- Reusable Skeleton Templates -->
            <ng-template #contentItemSkeleton>
                <ngx-skeleton-loader count="1" appearance="line"
                    [theme]="{ height: '30px', width: '120px', margin: '0' }"></ngx-skeleton-loader>
            </ng-template>

        </mat-expansion-panel>
    </mat-accordion>
</div>